import type { BioContext } from '@ps/functions/bio/bioContext';
import { bioUrl } from '@ps/functions/bio/bioUrls';
import type { PopStoreExtendedSubscriptionLevel } from '@ps/models/lib/creator-subscription';

import type { CommunityChannel } from '../../community-channels/types/CommunityChannel';

/**
 * The subscribe-picker URL for the community "Subscribe Now and Join Channel"
 * action — mirrors PopshopRN's `_userAccessBlocker` →
 * `subscribeToCreator({ desiredAccessLevel: requiredLevel, minLevel: requiredLevel })`:
 * the channel's `minimumSubscriptionLevel` is both **preselected** (`defaultLevel`)
 * and **floored** (`minLevel`, so lower tiers render disabled and the viewer
 * can't subscribe below the level that would actually grant access).
 *
 * Shared by the full-screen join gate and the subscribe blocker modal so both
 * open the picker at the right tier.
 */
export function channelSubscribeHref(
  bioContext: BioContext,
  channel: CommunityChannel,
): string {
  // `ChannelSubscriptionLevel` and `PopStoreExtendedSubscriptionLevel` carry the
  // same string values (see `hasChannelSubscriptionAccess`); bridge the nominal
  // enum for the URL builder.
  const level =
    channel.minimumSubscriptionLevel as unknown as PopStoreExtendedSubscriptionLevel;
  return bioUrl(bioContext).subscribe({ defaultLevel: level, minLevel: level });
}
